import { Column } from "../components/Table"
import { generateStandardColumn } from "./generateCommonColumns"
import {
  formatCorrectAnswers,
  formatStudentAnswer,
  isStudentAnswerCorrect
} from "./tables"
import { questionsSkillsAndStandardsFormatter } from "./tables/performance"

export const generateInsightsColumns = (
  standardFrameworks: string[],
  subpage?: string
): Column[] => {
  const columns: Column[] = [
    {
      label: "Content",
      name: "questions_view.displayName",
      sortable: true
    },
    {
      label: "Number",
      name: "questions_view.number",
      sortableName: "questions_view.seq",
      sortable: true,
      align: "right"
    },
    {
      label: "Correct Answer",
      name: "questions_view.answers",
      sortable: false,
      sortableName: "questions_view.correctAnswer",
      type: "correctAnswers",
      formatter: formatCorrectAnswers
    },
    ...((subpage === "questions"
      ? [
          {
            label: "Viewed",
            name: "questions_view.viewedCount",
            sortable: true,
            type: "number",
            align: "right"
          },
          {
            label: "Answered",
            name: "questions_view.answersCount",
            sortable: true,
            type: "number",
            align: "right"
          },
          {
            label: "% Correct",
            name: "questions_view.correctPercent",
            sortable: true,
            type: "correctPercent",
            align: "right",
            formatter: (record, prop) => {
              return Number(record[prop] || 0) / 100
            }
          }
        ]
      : [
          {
            label: "Submitted Answer",
            name: "questions_view.response",
            type: "correct",
            typeProp: isStudentAnswerCorrect,
            formatter: formatStudentAnswer,
            sortable: false,
            sortableName: "questions_view.responseKey"
          },
          {
            label: "Attempts",
            name: "questions_view.attempt",
            sortable: true,
            align: "right"
          }
        ]) as Column[]),
    ,
  ]

  // Add Standards grouped column (for collapsible dropdown in settings)
  const standardColumns = generateStandardColumn(standardFrameworks)
  if (standardColumns) {
    columns.push(standardColumns)
  }

  columns.push({
    label: "Skills",
    name: "questions_view.reportingCategories",
    sortable: true,
    formatter: questionsSkillsAndStandardsFormatter
  })

  return columns
}
